import {Section} from 'common/components/items-menu/types';

export enum OptionsType {
  Button = `button`,
  Select = `select`,
  Sidebar = `side`,
}

interface OptionsBarBaseOption {
  type: OptionsType;
  name: string;
  icon: string;
  menuWidth?: number;
  hidden?: boolean;
}

export type OptionsBarButtonOption = OptionsBarBaseOption & {disabled?: boolean; eventName: string};

export type OptionsBarSelectOption = OptionsBarBaseOption & {
  type: OptionsType.Select;
  sections: Section[];
  showNumItems?: boolean;
  multiple?: boolean;
};

export type OptionsBarSideOption = OptionsBarBaseOption & {
  type: OptionsType.Sidebar;
  sections: Section[];
  showNumItems?: boolean;
  multiple?: boolean;
};

export type OptionsBarOption = OptionsBarButtonOption | OptionsBarSelectOption | OptionsBarSideOption;
